export default {
  namespaced: true,
  state: {
    banks: {
      data: null,
      key: null,
      isLoading: false
    }
  },
  getters: {
    getBanks(state) {
      return state.banks.data
    },
    getBanksKey(state) {
      return state.banks.key
    }
  },
  mutations: {
    setBanks(state, banks) {
      state.banks.data = banks.data
      state.banks.key = banks.key
    },
    setBanksLoading(state, flag) {
      state.banks.isLoading = flag
    }
  },
  actions: {
    setBanks({ commit }, banks) {
      commit('setBanks', {
        data: banks,
        key: new Date().getTime()
      })
    },
    setBanksLoading({ commit }, flag) {
      commit('setBanksLoading', flag)
    }
  }
}
